import CallIcon from '@mui/icons-material/Call';
import DomainIcon from '@mui/icons-material/Domain';
import PermContactCalendarIcon from '@mui/icons-material/PermContactCalendar';
import React from 'react';

import { Box } from '_lib/components/Box/Box';

import { StyledTab, StyledTabs } from '_lib/styles/PhoneCall.styled';

export const ThreeTabFooter = (props: {
  tabIndex: number;
  setTabIndex: React.Dispatch<React.SetStateAction<number>>;
}) => {
  const { tabIndex, setTabIndex } = props;

  return (
    <Box
      sx={(theme) => ({
        display: 'flex',
        flexDirection: 'column',
        width: '100%',
        alignItems: 'center',
        justifyContent: 'center',
        bgcolor: theme.palette.callPane.main,
        color: theme.palette.callPane.contrastText
      })}>
      <StyledTabs
        sx={{ width: '100%' }}
        variant='fullWidth'
        value={tabIndex}
        onChange={(_event: React.SyntheticEvent, newValue: number) => setTabIndex(newValue)}>
        <StyledTab icon={<CallIcon />} id='phoneCall-tab-0' value={0} />
        <StyledTab icon={<PermContactCalendarIcon />} id='phoneCall-tab-1' value={1} />
        <StyledTab icon={<DomainIcon />} id='phoneCall-tab-2' value={2} />
      </StyledTabs>
    </Box>
  );
};
